import React from 'react';
import IconRefresh from '../icon/icon-refresh';
import styles from './ResetButton.module.scss';

const ResetButton = ({ onClick, className }) => {
  return (
    <button onClick={onClick} className={`${styles.resetButton} ${className || ''}`}>
      Reset
      <IconRefresh />
    </button>
  );
};

export default ResetButton;
